// extracted by mini-css-extract-plugin
export default {"titleIcon":"styles_titleIcon__Ek3Ke"};